import type { IVtsExhibitor } from '../../Admin/Exhibitors/Exhibitors';
import type { BoothPalette } from '../brandPalette';
import styles from '../BoothOverlay.module.scss?module';

interface PromoBandProps {
  exhibitor: IVtsExhibitor;
  /** Colours reach the band through the --booth-* variables of the sheet. */
  palette: BoothPalette;
}

/** Deal line above the fascia: the VTS discount, or the order window without one. */
export default function PromoBand({ exhibitor }: PromoBandProps) {
  const discount = Number(exhibitor.discount_percent ?? 0);
  const orderEnd = formatOrderDate(exhibitor.order_end);

  if (discount > 0) {
    return (
      <div className={styles.promoBand}>
        <p className={styles.promoDeal}>
          {`VTS deal −${formatPercent(discount)} %`}
        </p>
        <p className={styles.promoTerms}>
          {`on the entire ${exhibitor.name} range · unlimited quantities`}
        </p>
        {orderEnd && (
          <span className={styles.promoPill}>{`Order until ${orderEnd}`}</span>
        )}
      </div>
    );
  }

  return (
    <p className={styles.promoLine}>
      {orderEnd
        ? `Order any quantity until ${orderEnd} · delivery after the show`
        : 'Order any quantity · delivery after the show'}
    </p>
  );
}

function formatPercent(value: number): string {
  return new Intl.NumberFormat('en-GB', { maximumFractionDigits: 1 }).format(
    value
  );
}

/**
 * Formats the calendar date of an ATOM timestamp ("4 May 2027"). The date part is taken as
 * written by the server, so the reader's time zone cannot shift it to the previous day.
 */
function formatOrderDate(atom?: string | null): string | null {
  const match = atom ? /^(\d{4})-(\d{2})-(\d{2})/.exec(atom) : null;
  if (!match) {
    return null;
  }
  const date = new Date(
    Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3]))
  );

  return new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(date);
}
